import { DateTime, DateTimeFormatOptions } from "luxon";

import { currentLanguage, numericDateLocale } from "../../i18n";

// Note: a JS Date keeps the browser's zone, as toLocaleDateString did; only a DateTime is in mine time.
const asDateTime = (value: DateTime | Date) => DateTime.isDateTime(value) ? value : DateTime.fromJSDate(value, { zone: "system" });

const written = (value: DateTime | Date, format: DateTimeFormatOptions) =>
  asDateTime(value).setLocale(numericDateLocale(currentLanguage())).toLocaleString(format);

export function formatDate(value: DateTime | Date, format?: DateTimeFormatOptions): string;
export function formatDate(value: DateTime | Date | null | undefined, format?: DateTimeFormatOptions): string | undefined;
export function formatDate(value: DateTime | Date | null | undefined, format: DateTimeFormatOptions = DateTime.DATE_SHORT) {
  return value == null ? undefined : written(value, format);
}

export function formatDateTime(value: DateTime | Date, format?: DateTimeFormatOptions): string;
export function formatDateTime(value: DateTime | Date | null | undefined, format?: DateTimeFormatOptions): string | undefined;
export function formatDateTime(value: DateTime | Date | null | undefined, format: DateTimeFormatOptions = DateTime.DATETIME_SHORT_WITH_SECONDS) {
  return value == null ? undefined : written(value, format);
}
